<app-header [animateShadow]="true">
  <button *ngIf="activateHandsetLayout$ | async" header-navigation mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <span header-title>{{ data ? 'Edit patient' : 'Add patient' }}</span>
  <button *ngIf="!(activateHandsetLayout$ | async)" header-actions mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <button *ngIf="activateHandsetLayout$ | async"
    header-actions
    type="submit"
    class="ml-auto"
    mat-flat-button
    color="primary"
    [disabled]="form.invalid"
    (click)="save()">
    Save
  </button>
</app-header>
<mat-dialog-content cdkScrollable>
  <form [formGroup]="form" autocomplete="off" class="d-flex flex-column">
    <app-profile-picture formControlName="profilePicture"></app-profile-picture>
    <mat-form-field>
      <mat-label>Pet name</mat-label>
      <input matInput formControlName="name" spellcheck="false" cdkFocusInitial>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Owner name</mat-label>
      <input matInput formControlName="ownerName" spellcheck="false">
    </mat-form-field>
    <app-species-form-field formControlName="species"></app-species-form-field>
    <app-breed-form-field formControlName="breed" [selectedSpeciesName]="form.value.species"></app-breed-form-field>
    <mat-accordion multi="true" displayMode="flat" [@.disabled]="disableAnimation">
      <mat-expansion-panel hideToggle class="mat-elevation-z0" [expanded]="showAdditionalInfo">
        <mat-expansion-panel-header expandedHeight="0">
          <mat-panel-title>
            <mat-icon>description</mat-icon>
            Add additional info
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field class="form-field-right">
          <mat-label>Weight</mat-label>
          <input type="number" matInput formControlName="weight" spellcheck="false">
          <span matSuffix class="medium-emphasis">kg</span>
        </mat-form-field>
        <app-age-form-field formControlName="birthDate"></app-age-form-field>
        <mat-radio-group formControlName="gender">
          <mat-radio-button value="M">Male</mat-radio-button>
          <mat-radio-button value="F">Female</mat-radio-button>
        </mat-radio-group>
      </mat-expansion-panel>
      <mat-expansion-panel hideToggle class="mat-elevation-z0" [expanded]="showContactInfo">
        <mat-expansion-panel-header expandedHeight="0">
          <mat-panel-title>
            <mat-icon>contact_page</mat-icon>
            Add contact info
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field>
          <mat-label>Owner email</mat-label>
          <input type="email" matInput formControlName="ownerEmail" spellcheck="false" autocomplete="nope">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Owner phone number</mat-label>
          <input type="tel" matInput formControlName="ownerPhoneNumber" spellcheck="false" autocomplete="nope">
        </mat-form-field>
      </mat-expansion-panel>
    </mat-accordion>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="d-none d-sm-flex" align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button type="submit" mat-flat-button color="primary" [disabled]="form.invalid" (click)="save()">Save</button>
</mat-dialog-actions>

<div *ngIf="loading$ | async" class="overlay">
  <mat-spinner></mat-spinner>
</div>